import {initElements} from "../define/shared";

export default function initNewsletterCta() {
    initElements(".newsletter-cta", cta => {
        const openBtn = cta.querySelector("[data-action=\"open-popup\"]");
        const popup = cta.querySelector(".popup");
        const closeBtn = cta.querySelector(".close");

        openBtn.addEventListener("click", () => popup.classList.add("is--open"));
        closeBtn.addEventListener("click", () => popup.classList.remove("is--open"));
    });
}
